const getFileName = (headers: any) => {
  const contentDisposition = headers['content-disposition'];
  return contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1];
};

export default getFileName;
